import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  wrapper: 'data-image-content',
  script: 'data-script',
}
const qsAll = {
  sections: 'data-section-type="image-with-text"',
}
const iObserver = new IntersectionObserver(items => {
  const target = items[0].target
  if (items[0].isIntersecting && target.querySelector(`[${qs.script}]`)) initSection(target)
})

const initSection = (section) => {
  const scriptElement = section.querySelector(`[${qs.script}]`)
  if(scriptElement) {
    const wrapper = section.querySelector(`[${qs.wrapper}]`)
    const scriptHtml = scriptElement.innerHTML
    scriptElement.remove()
    wrapper.innerHTML += scriptHtml
  }
}

export const setupImageWithText = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => iObserver.observe(section))
}